import { mapEnumToOptions } from '@abp/ng.core';

export enum ProjectTaskStatus {
  InProgress = 0,
  Completed = 1,
}

export const projectTaskStatusOptions = mapEnumToOptions(ProjectTaskStatus);
